import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
  darkBackground?: boolean;
  externalUrl?: string;
}

export const Logo: React.FC<LogoProps> = ({ className = '', darkBackground = false, externalUrl }) => {
  // Use white for dark backgrounds, primary-tomato for light backgrounds
  const fill = darkBackground ? 'white' : '#F55D3E';

  const logoContent = (
    <svg
      width="250"
      height="45"
      viewBox="0 0 250 45"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <style>
        {`@import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@600&display=swap');`}
      </style>
      <line
        x1="5" y1="22" x2="32" y2="22"
        stroke={fill}
        strokeWidth="4"
        strokeLinecap="round"
      />
      <line
        x1="5" y1="32" x2="24" y2="32"
        stroke={fill}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <line
        x1="5" y1="40" x2="16" y2="40"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <text
        x="50" y="45"
        fontFamily="'Rajdhani', sans-serif"
        fontSize="40"
        fontWeight="600"
        fill={fill}
        letterSpacing="1"
        transform="skewX(-8)"
      >
        TIMELY IRB
      </text>
    </svg>
  );

  return externalUrl ? (
    <a href={externalUrl} target="_blank" rel="noopener noreferrer">
      {logoContent}
    </a>
  ) : (
    <Link to="/">
      {logoContent}
    </Link>
  );
};